import { Container, Flex, Text } from '@chakra-ui/react';
import { Divider, Switch, Visible } from 'components';
import { useState } from 'react';


type TransportFilterProps = {
    onChange: (values: any) => void;
};

const TRANSPORT_OPTIONS = [
    {label: 'Airplane'}
];

const transportTile = (
    label: string,
    onChange: (label: string, value: string) => void,
    index: number
) => {
    return <Flex direction="column" paddingTop="10px" key={label}>
            <Flex direction="row" justifyContent="space-between" paddingBottom="20px" alignItems="center">
                <Text fontFamily="Montserrat" fontWeight={600} fontSize={15}>{label}</Text>
                <Switch onChange={(event) => onChange(label, event.target.value)} />
            </Flex>
            <Visible when={index + 1 !== TRANSPORT_OPTIONS.length}>
                <Divider />
            </Visible>
        </Flex>
};

const TransportFilter = ({onChange}: TransportFilterProps) => {
    const [transports, setTransports] = useState({});

    const onTransportChange = (name: string, value: string | number) => {
        setTransports({...transports, [name]: value});
        onChange(transports);
    };

    return <Container padding={10} width={400}>
       {TRANSPORT_OPTIONS.map((option, index) =>
            transportTile(option.label, onTransportChange, index)
        )}
    </Container>
}

export {TransportFilter};